// Module
var code = "<div class=\"container\"> <div class=\"wk-layout-centered-large\"> <div class=\"wk-layout-item\"> <fs-page-title>Offline</fs-page-title> <div>You are not connected to the internet. Please try again later.</div> </div> </div> </div>";
// Exports
module.exports = code;